import { STATIC_TRANSLATIONS } from '@/config/urlTranslations';

const LANG_KEYS = ['en_slug', 'de_slug', 'es_slug', 'fr_slug', 'pt_slug', 'ru_slug', 'it_slug', 'sv_slug', 'zh_slug'] as const;

/**
 * Resolve any localized slug to its page_key.
 * e.g. "/bewertungen" → "reviews", "/shop" → "shop"
 */
function resolvePageKey(slug: string): string | null {
  for (const t of STATIC_TRANSLATIONS) {
    for (const k of LANG_KEYS) {
      if (t[k] === slug) return t.page_key;
    }
  }
  return null;
}

/**
 * Checks whether a nav link should be shown as "active" based on the current path.
 * Handles localized slugs and parent-child relationships.
 */
export function isNavLinkActive(currentPath: string, linkHref: string): boolean {
  // Exact match (Home only matches exactly)
  if (linkHref === '/') {
    return currentPath === '/';
  }

  // Direct match
  if (currentPath === linkHref) {
    return true;
  }

  // Parent-child match (e.g. /blog/article-slug → /blog is active)
  if (currentPath.startsWith(linkHref + '/')) {
    return true;
  }

  // Resolve localized slug: compare page_keys
  const currentPageKey = resolvePageKey(currentPath);
  const linkPageKey = resolvePageKey(linkHref);
  if (currentPageKey && linkPageKey && currentPageKey === linkPageKey) {
    return true;
  }

  // Parent-child with localized slugs (e.g. currentPath starts with a localized parent)
  if (linkPageKey) {
    const entry = STATIC_TRANSLATIONS.find(t => t.page_key === linkPageKey);
    if (entry) {
      for (const k of LANG_KEYS) {
        const localizedSlug = entry[k];
        if (localizedSlug !== '/' && currentPath.startsWith(localizedSlug + '/')) {
          return true;
        }
      }
    }
  }

  return false;
}
